export default __webpack_public_path__ + "static/media/coloregg4.84cadf91.png";